/**
 * Will add to the parsed object a userAction field (PAUSE, CANCEL, ADD_BREAK_PRICE_STOP,ENTER_NOW).
 * Will also return a field called userActionDetails, which will try and describe what the userAction was/did.
 * As of right now, the only we have additional fields for it ADD_BREAK_PRICE_STOP, which will have the fields a) price, symbol,
 * and is saying that the user action was an attempt to add a break price on "addPriceSymbol" x, at "price" y. 
 * 
 * The following is a json example using the ADD_BREAK_PRICE_STOP user action:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645465317063,
	"notificationDetails": {"errorType":"USER_ACTION","notificationType":"ERROR","userAction":"ADD_BREAK_PRICE_STOP","userActionDetails":{"addPriceSymbol":"XYZ","price":22.0,"userAction":"ADD_BREAK_PRICE_STOP"},"TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "NO_POSITION",
	"statusDetails": {"symbol":"XYZ"},
	"date": "2022-02-21T12:41:58.065-0500",
	"timestamp": "1645465318065"
}

 * @param {*} notificationDetails 
 * @param {*} parsedObject 
 */
export function userActionParser(notificationDetails, parsedObject) {
  if (!parsedObject) {
    parsedObject = {
      userAction: null,
      userActionDetails: null,
      errorType: 'USER_ACTION',
    };
  }
  if (notificationDetails) {
    parsedObject.userAction = notificationDetails.userAction ?? null;
    if (notificationDetails.userActionDetails) {
      if (parsedObject.userAction === 'ADD_BREAK_PRICE_STOP') {
        //todo refactor to make more robust
        parsedObject.userActionDetails = {};
        parsedObject.userActionDetails.addPriceSymbol =
          notificationDetails.userActionDetails.addPriceSymbol;
        parsedObject.userActionDetails.price =
          notificationDetails.userActionDetails.price;
      }
    }
  }
  return parsedObject;
}
